let componentsGetNormalNameMixin = {
    methods: {
        componentsGetNormalName: function(thisNameObj) {
            // console.log(thisNameObj)
            let returnName = ''
            if (thisNameObj.en) {
                returnName = thisNameObj.en
            } else {
                for (const key in thisNameObj) {
                    const thisName = thisNameObj[key]
                    if (thisName) {
                        returnName = thisName
                        break
                    }
                }
            }
            
            return returnName
        }
    }
}

export default componentsGetNormalNameMixin